import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

interface CustomTableHeaderProps {
  columns: any[];
}

const CustomTableHeader = ({ columns }: CustomTableHeaderProps) => {
  return (
    <TableHead>
      <TableRow>
        {columns.map((column: any) => (
          <TableCell key={column.id} align={column.align || "center"}>
            {column.headerRender ? column.headerRender() : column.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};
export default CustomTableHeader;
